 <template>
  <footer class="footer" role="contentinfo">
    <div class="footer__background">
      <div class="footer__container">
        <div class="footer__cards">
          <h2 class="footer__title">{{$t('footer.information-column-title')}}:</h2>
          <router-link :to="{name:'news-list'}"
                       class="footer__link"
                       v-t="'footer.news-link'">
          </router-link>
          <a :href="config.links.regulations" class="footer__link" v-t="'footer.regulations-link'"></a>
          <a :href="config.links.agreement" class="footer__link" v-t="'footer.user-agreement-link'"></a>
        </div>
        <div class="footer__cards">
          <h2 class="footer__title">{{$t('footer.support-column-title')}}:</h2>
          <a href="tel:+375292171313" class="footer__link">+375 29 217-13-13</a>
	  <a href="tel:+375172399988" class="footer__link">+375 17 239-99-88</a>
          <a href="mailto:tender@mts.by" class="footer__link">tender@mts.by</a>
          <p class="footer__link" v-html="$t('footer.address-link')"></p>
        </div>
        <div class="footer__cards">
          <h2 class="footer__title">{{$t('footer.help-column-title')}}:</h2>
          <button class="gui-btn gui-btn--link footer__link" v-t="'footer.ask-question-link'" @click.prevent="onAskQuestionClick"></button>
          <a :href="config.links.guide" class="footer__link" v-t="'footer.guide-link'"></a>
          <a :href="config.links.signature" class="footer__link" v-t="'footer.digital-signature-link'"></a>
          <button class="gui-btn gui-btn--link footer__link"  v-t="'footer.complain-link'" @click.prevent="onSentComplaintClick"></button>
        </div>
      </div>
    </div>

    <create-message-dialog ref="createMessage"></create-message-dialog>
  </footer>
</template>

<script>
  import MessageTheme from '@/api/types/message-theme'
  import CreateMessageDialog from '@/components/messages/dialogs/CreateMessage'

  export default {
    components: {
      CreateMessageDialog
    },

    methods: {
      onAskQuestionClick() {
        this.$refs.createMessage.open({
          forAdmin: true,
          anonymous: !this.$store.getters.isAuthorized,
          theme: new MessageTheme(MessageTheme.QUESTION)
        })
      },

      onSentComplaintClick() {
        this.$refs.createMessage.open({
          forAdmin: true,
          anonymous: !this.$store.getters.isAuthorized,
          theme: new MessageTheme(MessageTheme.COMPLAINT)
        })
      }
    }
  }
</script>

<style scoped>
  .footer__link {
    text-decoration: none !important;
  }
</style>
